import { takeLatest, call, put } from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_REQUEST_REPORT, SET_REQUEST_REPORT, REQUEST_REPORT_REQUEST_FAILED, SENDING_REQUEST_REPORT_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* requestReportSave(action) {
  const { data } = action;
  try {
    yield put({
      type: SENDING_REQUEST_REPORT_REQUEST,
      rRData: '',
      isRRSending: true,
      isRRSuccess: false,
      rRError: false,
    });
    const response = yield call(api.reports.requestReport, data);
    if (response) {
      yield put({
        type: SET_REQUEST_REPORT,
        rRData: response,
        isRRSending: false,
        rRError: false,
        isRRSuccess: true,
      });
    } else {
      yield put({
        type: REQUEST_REPORT_REQUEST_FAILED,
        rRData: null,
        isRRSending: false,
        rRError: true,
        isRRSuccess: false,
        rRMsg: response.errorMsg,
      });
    }
  } catch (e) {
    yield put({
      type: REQUEST_REPORT_REQUEST_FAILED,
      rRMsg: e.message,
      isRRSending: false,
      rRError: true,
      isRRSuccess: false,
      rRData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchRequestReportSave() {
  yield takeLatest(GET_REQUEST_REPORT, requestReportSave);
}
